import axios from 'axios';
import { ServiceApi } from "./Api";
import { ServiceConfig } from "./Config";
async function loadConfig() {
    try {
        const response = await axios.get('config.json');
        return response;
    } catch (error) {
        console.error('Falha ao carregar configuração', error);
        throw error;
    }
}

export async function getPortalConfigs() {
    try {
        const serviceConfig = new ServiceConfig();
        const res = await serviceConfig.GetConfig();

        let arr = [];

        if (Array.isArray(res?.data)) {
            arr = res.data;
        } else if (Array.isArray(res)) {
            arr = res;
        } else if (typeof res?.data === "string") {
            arr = JSON.parse(res.data);
        } else if (typeof res === "string") {
            arr = JSON.parse(res);
        } else {
            console.error("Formato inesperado de resposta:", res);
            return {};
        }

        const config = {};
        arr.forEach(item => {
            config[item.Key] = {
                id: item.Id,
                value: item.Value
            };
        });

        return config;
    } catch (err) {
        console.error("Erro ao buscar configurações do portal:", err);
        return {};
    }
}

async function createInstance(unidadeId) {
    const configFile = await loadConfig();
    const portalConfigs = await getPortalConfigs();

    const fallbackBaseURL = configFile?.data?.servicoPrinter; // padrão do config.json
    let baseURL = fallbackBaseURL;

    const servicoUnico =
        portalConfigs["ENDPOINT_UNICO_SERVICO_ONDEMAND_PORTAL"]?.value === "true";

    const endpointUnico =
        (portalConfigs["ENDPOINT_SERVICO_ONDEMAND_PORTAL"]?.value || "").trim();

    // 1) Modo "único serviço"
    if (servicoUnico) {
        // usa endpoint único se estiver preenchido; senão mantém fallback do config.json
        if (endpointUnico) {
            baseURL = endpointUnico;
        }
        return axios.create({ baseURL });
    }

    // 2) Modo "por unidade"
    if (unidadeId) {
        try {
            const serviceConfig = new ServiceConfig();
            const endpointOnDemand = await serviceConfig.getEndpointOnDemand(unidadeId);

            if (endpointOnDemand) {
                baseURL = endpointOnDemand;
            }
        } catch (err) {
            console.warn("Falha ao buscar endpoint onDemand; usando fallback do config.json", err);
        }
    }

    return axios.create({ baseURL });
}

export async function listarJob(AcNumber, unidadeId) {
    const instance = await createInstance(unidadeId);
    try {
        const endpoint = `/Job/PostListarJobs`;
        const response = await instance.post(endpoint, { AcNumber });
        return response.data;
    } catch (error) {
        console.error('Erro ao listar os jobs:', error);
        return false;
    }
}

export async function BuscarImagensLista(jobId, unidadeId) {
    const instance = await createInstance(unidadeId);
    try {
        const endpoint = '/Job/PostBuscarImagensListaResult';
        const response = await instance.post(endpoint, { Id: jobId });
        return response.data;
    } catch (error) {
        console.error('Erro ao carregar lista de imagens', error);
        throw error;
    }
}

export async function GetProgress(jobId) {
    const instance = await createInstance();
    try {
        const endpoint = `/Printer/GetProgress`;
        const response = await instance.get(endpoint, {
            params: { Id: jobId }
        });
        //document.getElementById('progress').innerText = `(${response.data.progress}%)`;
        return response;
    } catch (error) {
        console.error('Erro ao buscar progresso', error);
        throw error;
    }
}

export async function GetProgressList(jobs) {
    const instance = await createInstance();
    try {
        const endpoint = '/Printer/GetProgressList';
        const response = await instance.get(endpoint, {
            params: { Id: jobs }
        });
        //document.getElementById('progress').innerText = `(${response.data.progress}%)`;
        return response;
    } catch (error) {
        console.error('Erro ao buscar progresso', error);
        throw error;
    }
}

export async function PrintJobId(jobId, unidadeId) {
    const instance = await createInstance(unidadeId);
    try {
        const endpoint = '/Printer/PostExtractPDF';
        const response = await instance.post(endpoint, { Id: jobId }, { responseType: 'blob' });
        return response;
    } catch (error) {
        console.error('Erro ao imprimir job', error);
        throw error;
    }
}

export async function PrintAllJobs(jobs) {
    const instance = await createInstance();
    try {
        const endpoint = '/Printer/PostExtractAllJobsPDF';
        const response = await instance.post(endpoint, jobs, { responseType: 'blob' });
        return response;
    } catch (error) {
        console.error('Erro ao imprimir todos os jobs', error);
        throw error;
    }
}
